import { render, staticRenderFns } from "./MyPendingPolicies.vue?vue&type=template&id=9c8e1dba&"
import script from "./MyPendingPolicies.vue?vue&type=script&lang=js&"
export * from "./MyPendingPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports